import { useLocation, useParams } from 'react-router-dom';
import WidgetConfigurator from './components/widgets';
import { useEffect, useState } from 'react';
import { GET_WIDGET } from '../../../../constants/endpoints';
import axios from 'axios';

const CustomizeWidgets = () => {
    const params = useParams();
    const targetId = params?.campaign_id;
    const campaignType = params?.type;
    const widgetType = params?.widget_type;
    const [dataLoader, setDataLoader] = useState(false);
    const [campaignWidgetData, setCampaignWidgetData] = useState(null);
    useEffect(() => {
        setDataLoader(true);
        axios.get((GET_WIDGET + `${targetId}/${campaignType}`))
            .then((res) => {
                setDataLoader(false);
                if (res?.data?.status) {
                    setCampaignWidgetData(res?.data?.response);
                }
            }).catch((error) => {
                setDataLoader(false);
            });
    }, [])

    return (
        <>
        <h5>Configuration</h5>
        <p className="text-muted mb-2">
            Any customizations made here will display on your page upon a refresh. Be sure to review your changes before clicking Publish.
        </p>
        {!dataLoader ?
        <WidgetConfigurator widget={widgetType} widgets={campaignWidgetData?.widget} target_id={targetId} campaignType={campaignType} title={campaignWidgetData?.campaign_title} desc={campaignWidgetData?.featured_campaign_desc}/>
        : ''}

        </>
    );
};

export default CustomizeWidgets;
